export default {
  methods: {
    formatPriceISK(int) {
      const price = new Intl.NumberFormat('de-DE').format(int);
      return `${price} kr.`;
    },
    formatPrice(int) {
      const price = new Intl.NumberFormat('de-DE').format(int);
      return `${price}`;
    },
  },
};
